import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DurationRange } from '@app-core/models/core.model';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
import { AssetDriverSelectionModalComponent } from '@app-shared/components/asset-driver-selection-modal/asset-driver-selection-modal.component';

@Component({
  selector: 'app-page-filter',
  templateUrl: './page-filter.component.html',
  styleUrls: ['./page-filter.component.scss'],
})
export class PageFilterComponent implements OnInit {
  @Input() public durationRange: DurationRange;
  @Input() public homeTags: any[] = [];

  public isAdmin = false;
  public isDriverCentric = this.accessService.isDriverCentric;

  @Output()
  public changeDuration: EventEmitter<any> = new EventEmitter();
  @Output()
  public changeSearchByTags: EventEmitter<any> = new EventEmitter();

  public entityType = ['asset', 'driver'];

  constructor(
    public dataService: DataService,
    public accessService: AccessService,
    private dialog: MatDialog,
    public durationService: DurationRangeService,
    private mixpanelService: MixPanelService
  ) {}

  ngOnInit(): void {
    const { fleets } = this.accessService.getLoginInfo() || {};
    if (fleets?.[0]?.role?.isAdmin) {
      this.isAdmin = true;
    }

    this.dataService._isDriverCentric.subscribe((val) => {
      this.isDriverCentric = val;
    });
  }

  public durationChange(duration: DurationRange): void {
    this.changeDuration.emit(duration);
  }

  public selectedTags(tag: any): void {
    this.changeSearchByTags.emit(tag);
  }

  onToggleChange() {
    const dialogRef = this.dialog.open(AssetDriverSelectionModalComponent, {
      panelClass: ['asset-driver-modal', 'mobile-modal'],
      position: { top: '24px', bottom: '24px' },
      autoFocus: false,
      disableClose: true,
      data: {
        metadata: {
          driverCentric: this.isDriverCentric,
        },
        showConfirmation: true,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.isDriverCentric = this.isDriverCentric;
      } else {
        this.isDriverCentric = !this.isDriverCentric;
      }
    });
  }
  handleClick() {
    this.dataService?.openFaq(this.isDriverCentric ? 'DriverCentric' : 'AssetCentric');
    this.mixpanelService.track('button-clicked/home-page/Driver/Asset Centric-FAQ-opned');
  }
}
